import { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import loadedGif from "./Loader.gif";

import "./TicketPage.css";

const TicketPage = () => {
  const [buffer, setBuffer] = useState(true);

  const [hasError, setHasError] = useState(false);
  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState("");
  const [slack, setSlack] = useState("");

  const [TicketInformation, setTicketInformation] = useState({});

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const status = queryParams.get("status");
    const slack = queryParams.get("slack");

    if (status === null || slack === null || status === "" || slack === "") {
      window.location.assign("/");
    } else {
      setSlack(slack);
      setBuffer(false);
      setStatus(status);
    }
  }, []);

  const timeCalc = (time) => {
    const hours = Math.floor(time / 60);
    const minutes = time % 60;
    if (hours === 0) return minutes + "min";
    return hours + "hr " + minutes + "min";
  };
  useEffect(() => {
    if (status && slack) {
      fetch(`${process.env.REACT_APP_DEV_API_URL}/gds/reservation-info`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        body: JSON.stringify({
          tran_id: slack,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.success === true) {
            setLoading(false);
            setTicketInformation(res.data);
          } else {
            setHasError(true);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [status, slack]);

  const printRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  return (
    <>
      {!buffer && (
        <>
          {hasError ? (
            <div
              className="d-flex justify-content-center align-items-center flex-column"
              style={{ height: "80vh" }}
            >
              <span
                style={{
                  textAlign: "center",
                }}
              >
                Sorry ! <br /> Your PNR is not found. duo to some technical
                issue.
                <br />
                Please try again later.
              </span>
            </div>
          ) : (
            <>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center flex-column"
                  style={{ height: "80vh" }}
                >
                  <loadedGif />
                  <span>Preparing...</span>
                </div>
              ) : (
                <>
                  {" "}
                  <div>
                    <div
                      className="body0container"
                      style={{
                        fontSize: "15px",
                        backgroundColor: "#f7f7f7",
                        fontFamily: "Poppins",
                        fontWeight: "400",
                        lineHeight: "1.5",
                        color: "#212529",
                        textAlign: "left",
                      }}
                    >
                      <div
                        className="main0container"
                        style={{
                          width: "100%",
                          paddingRight: "17px",
                          paddingLeft: "15px",
                          marginRight: "auto",
                          maxWidth: "950px",
                          marginLeft: "auto",
                        }}
                      >
                        <div style={{ justifyContent: "center" }}>
                          <div
                            style={{
                              paddingRight: "15px",
                              paddingLeft: "15px",
                            }}
                          >
                            <div style={{ textAlign: "right" }}>
                              <button
                                style={{
                                  color: "#fff",
                                  backgroundColor: "#001787",
                                  textDecoration: "none",
                                  borderColor: "#001787",
                                  marginBottom: "1rem",
                                  display: "inline-block",
                                  border: "1px solid transparent",
                                  padding: "0.375rem 0.75rem",
                                  borderRadius: "0.25rem",
                                  boxShadow:
                                    "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
                                  fontSize: "1rem",
                                }}
                                onClick={handlePrint}
                              >
                                <i class="flaticon2-printer"></i>
                                Print PDF
                              </button>
                            </div>
                            <div className="wrapper_">
                              <div className="invoice-wrap" ref={printRef}>
                                <div style={{ marginBottom: "1.5 rem" }}>
                                  <div>
                                    <img
                                      src="data:image/png;base64,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"
                                      class="invoice-logo"
                                      alt="hello"
                                    />
                                  </div>
                                </div>
                                <h4
                                  style={{
                                    paddingBottom: "1px",
                                    paddingTop: "0.5 rem",
                                    marginBottom: "6px",
                                    borderBottom: "2px solid #dee2e6",
                                    borderColor: "#333",
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    lineHeight: "1.2",
                                    marginTop: "0",
                                  }}
                                >
                                  <span
                                    style={{
                                      marginRight: "1rem",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {TicketInformation.journey_start}
                                    <small
                                      style={{
                                        marginRight: "2px",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      <i
                                        class="fa fa-caret-right"
                                        style={{ fontSize: "20px" }}
                                      ></i>
                                    </small>
                                    {TicketInformation.journey_end}
                                  </span>
                                  TRIP TO
                                  <span
                                    style={{
                                      marginLeft: "12px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {TicketInformation.last_airport}
                                  </span>
                                  {","}
                                  <span
                                    style={{
                                      marginLeft: "12px",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {
                                      TicketInformation.flights_info[0]
                                        .airline_details
                                    }
                                  </span>
                                </h4>
                                <div
                                  style={{
                                    marginRight: "-15px",
                                    marginLeft: "-15px",
                                    marginBottom: "15px",
                                    display: "flex",
                                  }}
                                >
                                  <div
                                    style={{
                                      paddingLeft: "15px",
                                      maxWidth: "50%",
                                      flex: "0 0 50%",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontSize: "15px",
                                        color: "#3c3c3c",
                                        fontWeight: "400",
                                      }}
                                    >
                                      PREPARED FOR
                                    </div>
                                    {TicketInformation.pxn_list !== undefined &&
                                      TicketInformation.pxn_list.map((pxn) => (
                                        <div
                                          style={{
                                            fontWeight: "600",
                                            fontSize: "19px",
                                            color: "#3a3a3a",
                                            lineHeight: "22px",
                                          }}
                                        >
                                          <span>
                                            {pxn?.pxn_title
                                              ? pxn.pxn_title
                                              : ""}{" "}
                                          </span>
                                          {pxn.pxn_name}
                                        </div>
                                      ))}
                                  </div>

                                  <div
                                    style={{
                                      fontWeight: "500",
                                      textTransform: "uppercase",
                                      fontSize: "13px",
                                      color: "#464646",
                                    }}
                                  >
                                    Travel Consultant — Skytrip
                                  </div>
                                </div>
                                <div
                                  style={{
                                    marginRight: "0",
                                    marginLeft: "0",
                                    paddingBottom: "0",
                                    marginBottom: "0",
                                    borderBottom: "2px solid #dee2e6",
                                    borderColor: "#333",
                                    display: "flex",
                                  }}
                                >
                                  <div
                                    style={{
                                      paddingRight: "0",
                                      paddingLeft: "0",
                                      flex: "0 0 66.666667%",
                                      maxWidth: "66.666667%",
                                    }}
                                  >
                                    <div style={{ lineHeight: "15px" }}>
                                      RESERVATION CODE :{" "}
                                      {TicketInformation?.reservation_code}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      paddingRight: "0",
                                      paddingLeft: "0",
                                      flex: "0 0 66.66667%",
                                    }}
                                  ></div>
                                </div>

                                {TicketInformation?.flights_info &&
                                  TicketInformation.flights_info.map((inf) => (
                                    <>
                                      <div
                                        style={{
                                          marginBottom: "1rem",
                                          marginTop: "1rem",
                                          display: "flex",
                                          alignItems: "center",
                                          marginRight: "-15px",
                                          marginLeft: "-15px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            display: "0 0 50%",
                                            paddingLeft: "15px",
                                            maxWidth: "45%",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "left",
                                            }}
                                          >
                                            <i
                                              className="fa fa-plane fa-6"
                                              style={{
                                                fontSize: "40px",
                                                color: "#3a3a3a",
                                              }}
                                              aria-hidden="true"
                                            ></i>
                                            <span
                                              style={{
                                                marginLeft: "0.5rem",
                                                textTransform: "uppercase",
                                                paddingTop: "12px",
                                              }}
                                            >
                                              DEPARTURE: {inf.departure_date}
                                            </span>
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            paddingLeft: "5px",
                                            paddingRight: "15px",
                                            flex: "0 0 50%",
                                            maxWidth: "55%",
                                            flexDirection: "flex-end",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontWeight: "200",
                                              fontSize: "small",
                                            }}
                                          >
                                            Please verify flight times prior to
                                            departure
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          marginBottom: "0.5rem",
                                          marginRight: "0",
                                          display: "flex",
                                          marginLeft: "0",
                                        }}
                                      >
                                        <div
                                          style={{
                                            maxWidth: "25%",
                                            flex: "0 0 25%",
                                            backgroundColor: "#e7e7e9",
                                            padding: "10px",
                                            borderBottomLeftRadius: "30px",
                                            paddingLeft: "16px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontWeight: "500",
                                              lineHeight: "15px",
                                            }}
                                          >
                                            {inf.airline_details}
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "700",
                                              marginBottom: "3px",
                                            }}
                                          >
                                            {inf.airline_code}{" "}
                                            {inf.flight_number}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              fontWeight: "400px",
                                              paddingTop: "3px",
                                              lineHeight: "11px",
                                            }}
                                          >
                                            Duration:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "400",
                                              marginBottom: "4px",
                                              fontSize: "12px",
                                            }}
                                          >
                                            {timeCalc(inf.duration_minutes)}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "12px",
                                              lineHeight: "10px",
                                              paddingTop: "6px",
                                            }}
                                          >
                                            Cabin:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "12px",
                                              textTransform: "lowercase",
                                              paddingBottom: "5px",
                                            }}
                                          >
                                            {inf.cabin_class}
                                          </div>
                                          {/* <div style={{ fontSize: "12px" }}>
                                            Status:
                                          </div>
                                          <div
                                            style={{
                                              fontWeight: "300",
                                              fontSize: "12px",
                                              lineHeight: "11px",
                                            }}
                                          >
                                            Confirmed
                                          </div> */}
                                        </div>

                                        <div
                                          style={{
                                            overflow: "hidden",
                                            textAlign: "center",
                                            paddingRight: "0",
                                            paddingLeft: "0",
                                            border: "1px solid #dee2e6",
                                            borderColor: "#707070",
                                            flex: "0 0 50%",
                                            maxWidth: "50%",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingLeft: "0.5rem",
                                              paddingRight: ".5rem",
                                              paddingBottom: ".5rem",
                                              alignItems: "center",

                                              marginRight: "0",
                                              marginLeft: "0",
                                              display: "flex",
                                            }}
                                          >
                                            <div
                                              style={{
                                                paddingRight: "0",
                                                textAlign: "left",
                                                paddingLeft: "0px",
                                                paddingTop: "9px",
                                                flexBasis: 0,
                                                flexGrow: "1",
                                                minWidth: 0,
                                                maxWidth: "100%",
                                              }}
                                            >
                                              <h4
                                                style={{
                                                  lineHeight: "1",
                                                  fontSize: "19px",
                                                  fontWeight: "500",
                                                  color: "#5d5d5d",
                                                  marginBottom: "0",
                                                  marginTop: "0",
                                                }}
                                              >
                                                {inf.from_airport}
                                              </h4>
                                              <div
                                                style={{
                                                  textTransform: "uppercase",
                                                  fontSize: "13px",
                                                }}
                                              >
                                                {inf.from_location}
                                              </div>
                                            </div>
                                            <i
                                              className="fas fa-caret-right"
                                              style={{ marginLeft: "10px" }}
                                            ></i>
                                            <div
                                              style={{
                                                paddingRight: "0",
                                                paddingLeft: "0",
                                                flexBasis: "0",
                                                paddingTop: "9px",
                                                flexGrow: "1",
                                                minWidth: "0",
                                                maxWidth: "100%",
                                                textAlign: "center",
                                              }}
                                            >
                                              <h4
                                                style={{
                                                  lineHeight: "1",
                                                  fontSize: "19px",
                                                  fontWeight: "500",
                                                  color: "#5d5d5d",
                                                  marginBottom: "0",
                                                  marginTop: "0",
                                                }}
                                              >
                                                {inf.to_airport}
                                              </h4>
                                              <div
                                                style={{
                                                  textTransform: "uppercase",
                                                  fontSize: "13px",
                                                }}
                                              >
                                                {inf.to_location}
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            style={{
                                              height: "100%",
                                              textAlign: "center",
                                              justifyContent: "space-between",
                                              borderTop: "1px solid #dee2e6",
                                              borderColor: "#707070",
                                              marginRight: 0,
                                              marginLeft: 0,
                                              display: "flex",
                                            }}
                                          >
                                            <div
                                              style={{
                                                paddingLeft: "9px",
                                                paddingRight: "1rem",
                                                paddingTop: ".5rem",
                                                borderRight:
                                                  "1px solid #dee2e6",
                                                borderColor: "#707070",
                                                flexBasis: "0",
                                                flexGrow: "1",
                                                minWidth: "0",
                                                maxWidth: "100%",
                                                textAlign: "left",
                                                lineHeight: "18px",
                                              }}
                                            >
                                              Departing At : <br />
                                              <span
                                                style={{ fontSize: "12px" }}
                                              >
                                                {inf.departure_date}
                                              </span>
                                              <br />
                                              <strong
                                                style={{
                                                  textTransform: "lowercase",
                                                }}
                                              >
                                                {inf.departure_time} (Local
                                                time)
                                              </strong>
                                            </div>

                                            <div
                                              style={{
                                                paddingLeft: "9px",
                                                paddingRight: "1rem",
                                                paddingTop: ".5rem",
                                                // borderRight: '1px solid #dee2e6',
                                                // borderColor: '#707070',
                                                flexBasis: "0",
                                                flexGrow: "1",
                                                minWidth: "0",
                                                maxWidth: "100%",
                                                textAlign: "left",
                                                lineHeight: "18px",
                                              }}
                                            >
                                              Arrival At : <br />
                                              <span
                                                style={{ fontSize: "12px" }}
                                              >
                                                {inf.arrival_date}
                                              </span>
                                              <br />
                                              <strong
                                                style={{
                                                  textTransform: "lowercase",
                                                }}
                                              >
                                                {inf.arrival_time} (Local time)
                                              </strong>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          style={{
                                            borderBottom: "1px solid #dee2e6",
                                            borderRight: "1px solid #dee2e6",
                                            borderTop: "1px solid #dee2e6",
                                            borderColor: "#707070",
                                            flex: "0 0 25%",
                                            maxWidth: "25%",
                                            paddingTop: "4px",
                                            paddingLeft: "8px",
                                            lineHeight: "17px",
                                          }}
                                        >
                                          <div
                                            style={{ marginBottom: "0.5 rem" }}
                                          >
                                            Aircraft :<br />
                                            {inf.aircraft_type_name}
                                          </div>
                                          <div
                                            style={{ marginBottom: "0.5 rem" }}
                                          >
                                            Distance(Miles):
                                            <br />
                                            {inf.distance_miles}
                                          </div>
                                          <div
                                            style={{ marginBottom: "0.5rem" }}
                                          >
                                            Meals:{" "}
                                            {inf.meals ? inf.meals : "N/A"}
                                          </div>
                                        </div>
                                      </div>
                                      {/* {TicketInformation.baggage_info.map(bagInf)} */}
                                      <div
                                        style={{
                                          marginBottom: "13px",
                                          display: "flex",
                                          marginTop: "11px",
                                          marginRight: "-15px",
                                          marginLeft: "-15px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            flex: "0 0 100%",
                                            maxWidth: "100%",
                                            paddingRight: "15px",
                                            paddingLeft: "15px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "12px",
                                              lineHeight: "15px",
                                            }}
                                          >
                                            Checked Baggage (Kg): Adult,
                                            {
                                              TicketInformation.baggage_info[0]
                                                .checked_weight_kg
                                            }
                                            ; Checked Baggage: Adult, Please see
                                            the airline rules
                                          </div>

                                          <div
                                            style={{
                                              fontWeight: "400",
                                              fontSize: "12px",
                                              lineHeight: "15px",
                                            }}
                                          >
                                            Cabin Baggage (Pcs): Adult,
                                            {
                                              TicketInformation.baggage_info[0]
                                                .cabin_bag_pcs
                                            }
                                            ; Checked Baggage: Adult, Please see
                                            the airline rules
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        style={{
                                          display: "flex",
                                          marginBottom: "15px",
                                        }}
                                      >
                                        <div
                                          style={{
                                            flex: "0 0 50%",
                                            maxWidth: "33%",
                                            borderRight: "1px solid #dee2e6",
                                            borderColor: "#e7e7e9",
                                            marginTop: "3px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              marginBottom: ".25rem",
                                              backgroundColor: "#e7e7e9",
                                              fontSize: "12px",
                                            }}
                                          >
                                            Passenger name
                                          </div>
                                          {TicketInformation?.pxn_list &&
                                            TicketInformation.pxn_list.map(
                                              (inf) => (
                                                <div
                                                  style={{
                                                    fontWeight: "400",
                                                    fontSize: "11px",
                                                  }}
                                                >
                                                  <i className="fa fa-angle-double-right"></i>
                                                  <span
                                                    style={{
                                                      marginLeft: "5px",
                                                    }}
                                                  >
                                                    {inf.pxn_name}
                                                  </span>
                                                </div>
                                              )
                                            )}
                                        </div>
                                        <div
                                          style={{
                                            flex: "0 0 50%",
                                            maxWidth: "33%",
                                            marginTop: "3px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingLeft: "15px",
                                              paddingBottom: "2px",
                                              marginBottom: "0.25rem",
                                              backgroundColor: "#e7e7e9",
                                              fontSize: "11px",
                                            }}
                                          >
                                            Seats:
                                          </div>
                                          {TicketInformation?.pxn_list &&
                                            TicketInformation.pxn_list.map(
                                              (_) => (
                                                <div
                                                  style={{
                                                    paddingLeft: "15px",
                                                    fontWeight: "400",
                                                    fontSize: "11px",
                                                  }}
                                                >
                                                  Check-in Required
                                                </div>
                                              )
                                            )}
                                        </div>
                                        <div
                                          style={{
                                            flex: "0 0 50%",
                                            maxWidth: "33%",
                                            marginTop: "3px",
                                          }}
                                        >
                                          <div
                                            style={{
                                              paddingLeft: "15px",
                                              paddingBottom: "2px",
                                              marginBottom: "0.25rem",
                                              backgroundColor: "#e7e7e9",
                                              fontSize: "11px",
                                            }}
                                          >
                                            Ticket no:
                                          </div>
                                          {TicketInformation?.ticket_numbers ? (
                                            TicketInformation?.ticket_numbers.map(
                                              (inf) => (
                                                <>
                                                  {inf ? (
                                                    <div
                                                      style={{
                                                        fontWeight: "400",
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      <i className="fa fa-angle-double-right"></i>
                                                      <span
                                                        style={{
                                                          marginLeft: "5px",
                                                        }}
                                                      >
                                                        {inf}
                                                      </span>
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{
                                                        paddingLeft: "15px",
                                                        fontWeight: "400",
                                                        fontSize: "11px",
                                                      }}
                                                    >
                                                      Ticket not issued yet
                                                    </div>
                                                  )}
                                                </>
                                              )
                                            )
                                          ) : (
                                            <div
                                              style={{
                                                paddingLeft: "15px",
                                                fontWeight: "400",
                                                fontSize: "11px",
                                              }}
                                            >
                                              Ticket not issued yet
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
    </>
  );
};

export default TicketPage;
